import { useRouter } from "next/router"
import { useState } from "react"
import type { ViewMode } from "../../Auth/components/AuthModal"
import { getCouponCode } from "../../../logic/coupon/referralLink"
import { SignupForm } from "../components/SignupForm"
import { SignupComplete } from "../components/SignupComplete"
import { resolveSafeReturnUrl } from "../../../logic/auth/returnUrl"

const SignUp = () => {
  const router = useRouter()
  const [viewMode, setViewMode] = useState<ViewMode>("signup")
  const [registeredEmail, setRegisteredEmail] = useState("")
  const url = resolveSafeReturnUrl()
  const coupon = getCouponCode() ?? undefined

  const switchToLogin = () => router.push("/")
  const handleSignupSuccess = (email: string) => {
    setRegisteredEmail(email)
    setViewMode("signup-complete")
  }

  return (
    <>
      {viewMode === "signup" && <SignupForm onSuccess={handleSignupSuccess} url={url} coupon={coupon} />}
      {viewMode === "signup-complete" && (
        <SignupComplete email={registeredEmail} onClose={switchToLogin} buttonText="TOPへ" />
      )}
    </>
  )
}

export default SignUp
